/** ISO 3166-1 alpha-2 + E.164 dial codes for CommonPhoneInput */
export const PHONE_COUNTRY_OPTIONS = [
  { code: "IN", name: "India", dialCode: "+91" },
  { code: "US", name: "United States", dialCode: "+1" },
  { code: "GB", name: "United Kingdom", dialCode: "+44" },
  { code: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { code: "AU", name: "Australia", dialCode: "+61" },
  { code: "CA", name: "Canada", dialCode: "+1" },
  { code: "SG", name: "Singapore", dialCode: "+65" },
  { code: "DE", name: "Germany", dialCode: "+49" },
  { code: "FR", name: "France", dialCode: "+33" },
  { code: "NL", name: "Netherlands", dialCode: "+31" },
  { code: "CH", name: "Switzerland", dialCode: "+41" },
  { code: "SE", name: "Sweden", dialCode: "+46" },
  { code: "NO", name: "Norway", dialCode: "+47" },
  { code: "DK", name: "Denmark", dialCode: "+45" },
  { code: "FI", name: "Finland", dialCode: "+358" },
  { code: "IE", name: "Ireland", dialCode: "+353" },
  { code: "ES", name: "Spain", dialCode: "+34" },
  { code: "IT", name: "Italy", dialCode: "+39" },
  { code: "PT", name: "Portugal", dialCode: "+351" },
  { code: "BE", name: "Belgium", dialCode: "+32" },
  { code: "AT", name: "Austria", dialCode: "+43" },
  { code: "PL", name: "Poland", dialCode: "+48" },
  { code: "CZ", name: "Czech Republic", dialCode: "+420" },
  { code: "RO", name: "Romania", dialCode: "+40" },
  { code: "HU", name: "Hungary", dialCode: "+36" },
  { code: "GR", name: "Greece", dialCode: "+30" },
  { code: "TR", name: "Turkey", dialCode: "+90" },
  { code: "RU", name: "Russia", dialCode: "+7" },
  { code: "UA", name: "Ukraine", dialCode: "+380" },
  { code: "SA", name: "Saudi Arabia", dialCode: "+966" },
  { code: "QA", name: "Qatar", dialCode: "+974" },
  { code: "KW", name: "Kuwait", dialCode: "+965" },
  { code: "BH", name: "Bahrain", dialCode: "+973" },
  { code: "OM", name: "Oman", dialCode: "+968" },
  { code: "IL", name: "Israel", dialCode: "+972" },
  { code: "ZA", name: "South Africa", dialCode: "+27" },
  { code: "NG", name: "Nigeria", dialCode: "+234" },
  { code: "KE", name: "Kenya", dialCode: "+254" },
  { code: "EG", name: "Egypt", dialCode: "+20" },
  { code: "CN", name: "China", dialCode: "+86" },
  { code: "JP", name: "Japan", dialCode: "+81" },
  { code: "KR", name: "South Korea", dialCode: "+82" },
  { code: "HK", name: "Hong Kong", dialCode: "+852" },
  { code: "TW", name: "Taiwan", dialCode: "+886" },
  { code: "MY", name: "Malaysia", dialCode: "+60" },
  { code: "TH", name: "Thailand", dialCode: "+66" },
  { code: "ID", name: "Indonesia", dialCode: "+62" },
  { code: "PH", name: "Philippines", dialCode: "+63" },
  { code: "VN", name: "Vietnam", dialCode: "+84" },
  { code: "NZ", name: "New Zealand", dialCode: "+64" },
  { code: "MX", name: "Mexico", dialCode: "+52" },
  { code: "BR", name: "Brazil", dialCode: "+55" },
  { code: "AR", name: "Argentina", dialCode: "+54" },
  { code: "CL", name: "Chile", dialCode: "+56" },
  { code: "CO", name: "Colombia", dialCode: "+57" },
];

export const DEFAULT_PHONE_COUNTRY_CODE = "IN";

export function getPhoneCountryByCode(code) {
  return (
    PHONE_COUNTRY_OPTIONS.find((c) => c.code === code) ??
    PHONE_COUNTRY_OPTIONS.find((c) => c.code === DEFAULT_PHONE_COUNTRY_CODE)
  );
}

export function sanitizeNationalNumber(value) {
  return String(value ?? "").replace(/\D/g, "");
}

export function getPhoneNumberWithCountryCode(countryCode, nationalNumber) {
  const country = getPhoneCountryByCode(countryCode);
  const digits = sanitizeNationalNumber(nationalNumber);
  if (!digits) return "";
  return `${country.dialCode}${digits}`;
}

/** Parse +919876543210 → { countryCode, nationalNumber } when possible */
export function parseE164Phone(value) {
  const raw = String(value ?? "").trim();
  if (!raw.startsWith("+")) {
    return { countryCode: DEFAULT_PHONE_COUNTRY_CODE, nationalNumber: sanitizeNationalNumber(raw) };
  }

  const sorted = [...PHONE_COUNTRY_OPTIONS].sort(
    (a, b) => b.dialCode.length - a.dialCode.length,
  );
  const match = sorted.find((c) => raw.startsWith(c.dialCode));
  if (!match) {
    return { countryCode: DEFAULT_PHONE_COUNTRY_CODE, nationalNumber: sanitizeNationalNumber(raw.slice(1)) };
  }

  return {
    countryCode: match.code,
    nationalNumber: sanitizeNationalNumber(raw.slice(match.dialCode.length)),
  };
}
